import { BaseEntity } from '../../../core/models/base-entity.model';
import { ExternalFile } from '../../../shared/components/external-file/types';

export class Author extends BaseEntity<Author> {
  email = '';
  firstname = '';
  lastname = '';
  username = '';
  picture?: Pick<BaseEntity<Author>, 'id'>;
  profilePicture?: ExternalFile;
}
